import { AcuteAMRGrade } from "@nkr/enums/acute-amr-grade"
import { AcuteTCMRGrade } from "@nkr/enums/acute-tcmr-grade"
import { BiopsyReason } from "@nkr/enums/biopsy-reason"
import { IBANFFClassification } from "./banff-classification"

export interface ITransplantRejectionBiopsy {
    id: number,
    rejectionId: number,
    reason: BiopsyReason,
    isAbnormal: boolean | null,
    acuteAntibodyMediatedRejection: boolean,
    acuteAmrGrade: AcuteAMRGrade,
    borderlineRejection: boolean,
    acuteTCellMediatedRejection: boolean,
    acuteTcmrGrade: AcuteTCMRGrade,
    chronicActiveTCellMediatedRejection: boolean,
    interstitialFibrosisAndTubularAtrophy: boolean,
    iftaGrade: number,
    c4dStainingWithoutEvidenceOfRejection: boolean,
    otherFindings: string,
    banffClassification: IBANFFClassification
}